export const validateCode = value => {
  const code = (value || '').trim();

  return code.length === 6 && /^\d{6}$/.test(code);
};

export default validateCode;
